var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttatchment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24015",
    "data-name": "Path 24015",
    d: "M14.5,24A5.5,5.5,0,0,1,9,18.5V5.929a3.929,3.929,0,0,1,7.857,0V18.5a2.357,2.357,0,0,1-4.714,0V7.5a.786.786,0,1,1,1.571,0v11a.786.786,0,0,0,1.571,0V5.929a2.357,2.357,0,1,0-4.714,0V18.5a3.929,3.929,0,0,0,7.857,0V7.5A.786.786,0,0,1,20,7.5v11A5.5,5.5,0,0,1,14.5,24Z",
    transform: "translate(-9 -2)",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttatchment);
export default __webpack_public_path__ + "static/media/attatchment.8c081a365355515e5028ae682f0c7413.svg";
export { ForwardRef as ReactComponent };